export type ParticipantTitle = Readonly<{
    displayValue: string;
    value: string;
}>;

export const initialParticipantState: ParticipantTitle = {
    displayValue: '',
    value: '',
};
